import moment from 'moment';
import * as flights from 'core/flights';
import * as types from '../mutation-types';

export interface FlightSearchParamsState {
    params?: flights.FlightSearchParams;
}

// initial state
const state: FlightSearchParamsState = {
    params: undefined
};

// getters
const getters = {
    flightSearchParams: state => state.params
};

// actions
const actions = {};

// mutations
const mutations = {
    [types.SEARCH_FLIGHTS](state, newSearchParams: flights.FlightSearchParams) {
        if (!state.params) {
            state.params = {
                from: '',
                to: '',
                departure: moment().add(7, 'days').startOf('day').toDate(),
                return: moment().add(14, 'days').startOf('day').toDate(),
                roundtrip: true,
                class: flights.BookingClass.Economic,
                passengers: {
                    adults: 1,
                    children: 0,
                    infants: 0
                }
            };
        }

        if (newSearchParams) {
            state.params.from = newSearchParams.from;
            state.params.to = newSearchParams.to;
            state.params.departure = newSearchParams.departure;
            state.params.return = newSearchParams.return;
            state.params.roundtrip = newSearchParams.roundtrip;
            state.params.class = newSearchParams.class;
            state.params.passengers.adults = newSearchParams.passengers.adults;
            state.params.passengers.children = newSearchParams.passengers.children;
            state.params.passengers.infants = newSearchParams.passengers.infants;
        }
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};
